// extracted by mini-css-extract-plugin
export default {"image-preview":"ImagePreview_image-preview__6S6b1","image-wrapper":"ImagePreview_image-wrapper__2E8aW"};